//
// Forms JS
// --------------------------------------------------
// All the functions specifically for usage with freeform forms including:
// Populating hidden form fields
// Validation and formatting of the phone number field
// Sets error and success message position
// Pushes data to datalayer on form submission for GTM

import { formatMobileNumber } from "./helpers/format-mobile-number";
import { scrollToTarget } from "./helpers/scroll-to-target";
window.addEventListener('load', event => {

    // Function that pushes GA data through to datalayer for GTM
    // ...additional datalayer data can be added at time of form submission
    function gtmPush(event, formId, additional = {}) {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: event,
                formName: formId,
                ...additional
            });
        }
    }

    // Function that sets field values based on cookies etc.
    function setFormValues(form) {

        // Array of form fields and the new value that should be assigned to that field
        let formFields = [
            {
                handle: form.utmSource,
                newValue: Cookies.get('utm_source')
            },
            {
                handle: form.utmMedium,
                newValue: Cookies.get('utm_medium')
            },
            {
                handle: form.utmCampaign,
                newValue: Cookies.get('utm_campaign')
            },
            {
                handle: form.utmContent,
                newValue: Cookies.get('utm_content')
            },
            {
                handle: form.gaclientid,
                newValue: Cookies.get('_ga')?.slice(6)
            },
            {
                handle: form.gatrackid,
                newValue: typeof google_tag_manager === 'object' ? Object.keys(google_tag_manager).filter((key) => key.indexOf('G-') === 0) : ''
            },
            {
                handle: form.gclid,
                newValue: Cookies.get('ff_gclid')
            },
            {
                handle: form.pageUrl,
                newValue: window.location
            },
            {
                handle: form.pageTitle,
                newValue: form.dataset.pageTitle
            }
        ]

        // Assign form fields new values if they exist
        for (let field of formFields) {
            if (field.handle && field.newValue) {
                field.handle.value = field.newValue;
            }
        }
    }

    // Adds transition classes to notification, fades to 0 opacity and then hides from dom on transition finish
    function fadeOutNotification(form) {
        let notifications = form.querySelectorAll('.ff-form-errors, .ff-form-success');

        for (let notification of notifications) {
            notification.classList.add('transition-opacity', 'duration-500', 'delay-[15000ms]', 'flex', 'items-center');

            setTimeout(() => {
                notification.classList.add('opacity-0');
            }, 50);

            notification.addEventListener('transitionend', event => {
                notification.classList.add('hidden');
            }, { once: true });
        }
    }

    // Freeform functions
    let forms = document.querySelectorAll('form');

    for (let form of forms) {
        const formId = form.id;

        // Override Freeform default error/success message
        // Commented as should be set on form via cms, but could be useful for a dynamic message on a reusable form
        // freeform.setOption('errorBannerMessage', 'Error!');
        // freeform.setOption('successBannerMessage', 'Success!');

        // Run when freeform initialises
        form.addEventListener("freeform-ready", function (event) {
            // Phone Validation for: input[data-validate="mobile"]
            const phoneInput = form.querySelector('input[data-validate="mobile"]');
            const phoneValidationMessage = 'Please provide a valid Australian Mobile Phone number.';

            if (phoneInput) {
                phoneInput.addEventListener('change', (event) => {
                    const phoneVal = formatMobileNumber(phoneInput.value);

                    if (phoneInput.value !== phoneVal) {
                        phoneInput.value = phoneVal;
                    }

                    if (phoneVal.match(/^\+61 4\d{2} \d{3} \d{3}$/)) {
                        // Clear any errors on the input
                        phoneInput.setCustomValidity('');
                        phoneInput.reportValidity();
                    }

                    // no else statement here as we are matching existing validation flow from freeform where the errors only appear when attempting to submit
                });

                form.addEventListener('freeform-on-submit', function (submitEvent) {
                    if (!phoneInput.value.match(/^\+61 4\d{2} \d{3} \d{3}$/)) {
                        phoneInput.setCustomValidity(phoneValidationMessage);
                        phoneInput.reportValidity();

                        submitEvent.preventDefault();
                    }
                    else {
                        phoneInput.setCustomValidity('');
                        phoneInput.reportValidity();
                    }
                });
            }
        });

        // Runs when freeform has attempted a submission
        form.addEventListener('freeform-on-submit', function (event) {

            // Calls function to set dynamic field values
            setFormValues(form);
        });

        // Runs after ajax submit
        form.addEventListener('freeform-ajax-after-submit', function(event) {

            // Override error/success notification position on ajax submission
            let notifications = form.querySelectorAll('.ff-form-errors, .ff-form-success');
            let submitButton = form.querySelector('button[data-freeform-action="submit"]');

            for (let notification of notifications) {
                submitButton.closest('.freeform-column').appendChild(notification);
                fadeOutNotification(form);
            }
        });

        // Runs before ajax submit
        form.addEventListener('freeform-ajax-before-submit', function(event) {

            // Adds any additional requirements to GA data
            // payload = form data after 'freeform-on-submit' has run
            // payload.get('field handle') = associated value of that field handle
            const payload = event.data;

            form.dataLayerSubmission = {
                gaFormName: payload.get('gaformname'),
            };
        });

        // Runs after successful ajax submission
        form.addEventListener('freeform-ajax-success', function(event) {

            let formContainer = form.closest('div[data-form-complete]');

            if (formContainer) {
                formContainer.dataset.formComplete = 'true';
                setTimeout(() => {
                    formContainer.dataset.formComplete = 'false';
                }, 10000);
            }

            let thankyouMsg = form.closest('div').querySelector('p');
            if (thankyouMsg) {
                scrollToTarget(thankyouMsg)
            }

            // Pushes GA data through to datalayer
            gtmPush('formSubmitted', formId, {enquiryFormData: form.dataLayerSubmission});
        });
    }
});